export default {
    reptileURL:{
        OS:{
            url:{
                tw: 'https://www.habook.com/',
                cn: 'https://www.habook.com.cn/',
                en: 'https://www.habook.com/'
            },
            page:{
                news:{
                    tw: 'zh-tw/news.php',
                    cn: 'news.php',
                    en: 'en/news.php'
                },
                academic:{
                    tw: 'zh-tw/academic.php',
                    cn: 'academic.php',
                    en: 'en/academic.php'
                },
                event:{
                    tw: 'zh-tw/event.php',
                    cn: 'event.php',
                    en: 'en/event.php'
                }
            }
        }
    },
    apiUrl: {
        global: 'https://api2.teammodel.net',
        cn: 'https://api2.teammodel.cn',
        globalrc: 'https://api2-rc.teammodel.net',
        cnrc: 'https://api2-rc.teammodel.cn'
    },
    blobUrl: {
        global: 'https://coreblob.teammodel.net',
        cn: 'https://coreblob.teammodel.cn',
        globalrc: 'https://coreblob.teammodel.net',
        cnrc: 'https://coreblob.teammodel.cn',
    },
    ies5Api: {
        global: 'https://www.teammodel.net',
        cn: 'https://www.teammodel.cn',
        globalrc: 'https://ies5-rc.teammodel.net',
        cnrc: 'https://ies5-rc.teammodel.cn'
    },
    sokmgrApi: {
        global: 'https://sokratesmgr.teammodel.org',
        cn: 'https://sokratesmgr.teammodel.cn',
    },
    clientID: {
        global: 'b0b11521-0041-4cef-b002-1745d8706a9c',
        cn: 'be9ed3a6-4f8c-4eaa-8b62-9a269e8dc245',
        globalrc: 'b0b11521-0041-4cef-b002-1745d8706a9c',
        cnrc: 'be9ed3a6-4f8c-4eaa-8b62-9a269e8dc245'
    }
}
